import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import { MdModeEdit, MdClose } from 'react-icons/md';

import Alert from 'components/common/alert';

import { DATE_FORMAT_FOR_DISPLAY } from 'constants/appConstants';
import type { LeapfrogHistory } from 'interface/createUpdateForm';

type DesignationHistoryEntry = LeapfrogHistory['designationAreaHistory'][number] & {
  uid?: string;
};

interface DesignationAreaHistoryProps {
  history: DesignationHistoryEntry[];
  selectedDesignation: DesignationHistoryEntry | null;
  onUpdate: (designation: DesignationHistoryEntry) => void;
  onDelete: (designation: DesignationHistoryEntry) => void;
  disabled?: boolean;
}

const DesignationAreaHistory: React.FC<DesignationAreaHistoryProps> = (props) => {
  const {
    history: empStatusHistory,
    selectedDesignation,
    onUpdate: handleDesignationUpdateClick,
    onDelete: handleRemoveDesignationHistory,
    disabled,
  } = props;

  const removeDesignationHistory = (empDesignation: DesignationHistoryEntry) => {
    Alert.fire({
      icon: 'warning',
      title: 'Remove this Designation History',
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',

      preConfirm: () => {
        try {
          handleRemoveDesignationHistory(empDesignation);
        } catch (err) {
          Alert.showValidationMessage(`Request failed: ${String(err)}`);
        }
      },
    });
  };

  const employmentHistory = empStatusHistory.map((empDesignation, index) => {
    if (!empDesignation?.transitionDate) {
      return null;
    }
    const isLastElement = empStatusHistory.length - 1 === index;

    return (
      <div
        className="position-relative d-inline-block text-align--center employee-history-container"
        key={empDesignation.designation.id || empDesignation.uid}
      >
        <div
          className={classnames('employee-history mt-25 mb-10', {
            'employee-history-last': isLastElement,
          })}
        >
          <div className="capital-text employee-history-title">{empDesignation.designation.name}</div>
          <div className="employee-history-detail">
            {moment(empDesignation.transitionDate).format(DATE_FORMAT_FOR_DISPLAY)}
            {empDesignation.area && ', ' + empDesignation.area.name}
          </div>
          <button
            type="button"
            className={classnames('d-flex align-items-center edit-button mt-10 m-auto', {
              'active-edit': empDesignation && empDesignation === selectedDesignation,
            })}
            disabled={disabled}
            onClick={() => handleDesignationUpdateClick(empDesignation)}
          >
            <MdModeEdit />
            &nbsp;Edit
          </button>

          <button
            type="button"
            disabled={empStatusHistory.length === 1 || disabled}
            className="d-flex align-items-center mt-10 m-auto remove-button"
            onClick={() => removeDesignationHistory(empDesignation)}
          >
            <MdClose />
            &nbsp;Remove
          </button>
        </div>
      </div>
    );
  });

  return <div className="d-flex mb-30 mt-30 overflow-flex custom-scroll-bar">{employmentHistory}</div>;
};

export default DesignationAreaHistory;
